import React from 'react';

import { Box, BoxProps } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

export type SeparatorProps = BoxProps;

export const Separator = ({ my = '4x', width = '100%', ...rest }: SeparatorProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      data-testid="separator"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor={theme.colors.separator.primary.toString()}
      my={my}
      width={width}
      {...rest}
    />
  );
};

export default Separator;
